import * as React from 'react';
import { useCallback } from 'react';
import User from 'benchmarking-domain/user';
import { UserForm } from 'components/admin/users/user-form';
import useApi from 'hooks/use-api';
import { enqueueSnackbar } from 'notistack';
import { paths } from 'paths';
import { useNavigate } from 'react-router-dom';

export default function AddUser(): React.JSX.Element {
  const navigate = useNavigate();
  const { createUserWithAuth } = useApi();

  const submitChanges = useCallback(
    async (data: User) => {
      const createdUserId = await createUserWithAuth(data);

      if (createdUserId == undefined) {
        enqueueSnackbar('Something went wrong during creating user!', { variant: 'error' });
        return;
      }

      enqueueSnackbar('User has been added!', { variant: 'success' });
      navigate(paths.app.admin.users.getDetailsUrl(createdUserId));
    },
    [navigate, createUserWithAuth]
  );

  return <UserForm disableEmail={false} onSubmit={submitChanges} />;
}
